import type React from 'react';
import { lazy, Suspense } from 'react';
import { PageLoading } from '@/app/components/page-loading.tsx';
import { useAuth } from '@/app/hooks/auth-provider';
import { UserTypeEnum } from '../../types/user-type.ts';
import OnboardImportList from './onboard-import-list.tsx';
import OnboardImportView from './onboard-import-view.tsx';

const LazyOnboardImport = lazy(() => import('./OnboardImport'));

const OnboardImport = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => {
  const { user } = useAuth();

  return (
    <Suspense fallback={<PageLoading />}>
      {user?.userType === UserTypeEnum.Admin ? <LazyOnboardImport {...props} /> : null}
    </Suspense>
  );
};

export const onboardImportRoute = {
  path: '/onboard-import',
  element: <OnboardImport />,
  children: [
    {
      path: ':key',
      element: <OnboardImportView />,
    },
    {
      path: '',
      element: <OnboardImportList />,
    },
  ],
};

export default OnboardImport;
